import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useAtom } from "jotai";
import { getCorrectAnswerCoveragePercent } from "../helpers/coverage";
import { answeredState } from "../helpers/recoil";
import { menuColors } from "../theme/menuTheme";

const Score = ({ compact = false }: { compact?: boolean }) => {
  const [answeredList, setAnsweredList] = useAtom(answeredState);

  if (!answeredList?.length) {
    return null;
  }

  const correct = answeredList.filter((a) => a.answer === true).length;
  const pct = ((correct / answeredList.length) * 100).toFixed(0);
  const coverage = getCorrectAnswerCoveragePercent(answeredList).toFixed(1);

  if (compact) {
    return (
      <Box sx={{ textAlign: "left" }}>
        <Typography sx={{ mb: 1, fontSize: 18, fontWeight: 600, color: menuColors.accent }}>
          {correct}/{answeredList.length} correct ({pct}%)
        </Typography>
        <Typography sx={{ mb: 1, fontSize: 15, color: menuColors.text }}>
          Coverage: {coverage}%
        </Typography>
        <Button size="small" variant="outlined" onClick={() => setAnsweredList([])}>
          Clear score
        </Button>
      </Box>
    );
  }

  return (
    <>
      <Typography sx={{ color: menuColors.text, m: 0 }}>
        {correct}/{answeredList.length}
      </Typography>
      <Typography sx={{ color: menuColors.accent, m: 0 }}>{pct}%</Typography>
      <Typography sx={{ color: menuColors.text, m: 0, mt: 1 }}>
        Coverage: {coverage}%
      </Typography>
      <Button variant="outlined" onClick={() => setAnsweredList([])} sx={{ mt: 1 }}>
        Clear score
      </Button>
    </>
  );
};

export default Score;
